import { CatSkeleton } from '@blocks-react/components/Skeleton';

export const SystemLoader = () => {
  return (
    <div>
      <CatSkeleton size="xxl" width="332px" />
      <CatSkeleton size="lg" width="332px" />
      <CatSkeleton width="332px" />
      <CatSkeleton size="sm" width="332px" />
    </div>
  );
};

export default SystemLoader;
